import {
    app,
    Component,
    ojs,
    state,
    v,
    each,
    component,
} from "modular-openscriptjs";
import {
    pageInfo,
    eParse,
    either,
    monetary,
    redirect,
    showActionButton,
    scrollToTop,
    cartEmpty,
} from "../../helpers";
import { dc, PAGES } from "../../declarations";

import SearchIconBtn from "../Blocks/SearchIconBtn";
import Fab from "../Blocks/Fab";
import CartProductView from "../Views/CartProductView";
import SettingItem from "../SettingItem";
import Spinner, { SmallSpinner } from "../Blocks/Spinner";
import { $e } from "../../ojs.events";

const h = app("h");
const route = app("router");
const uc = app("uc");

ojs(SearchIconBtn, Fab, CartProductView, SettingItem, Spinner, SmallSpinner);

export default class CartPage extends Component {
    productList = {};
    actionCallbackId = null;
    actionButtonShown = false;

    render(cart, ...args) {
        let total = 0;
        let quantity = 0;
        let totalDiscount = 0;

        pageInfo(PAGES.CART);
        scrollToTop();

        return h.div(
            { class: "pt-md-5 pb-5 mb-5 container" },
            v(dc.cartLoaded, (cartLoadedState) => {
                if (!cartLoadedState.value) {
                    return h.div(
                        { class: "py-5 my-5 text-center" },
                        h.Spinner(),
                    );
                }

                let cartSize = Object.keys(cart.value)?.length;

                return h.div(
                    h.div(
                        { class: "row g-4" }, // Grid row with gap

                        // LEFT COLUMN: CART ITEMS (8/12)
                        h.div(
                            { class: "col-12 col-lg-8" },

                            // Header
                            h.h4(
                                { class: "mb-3 fw-bold text-dark" },
                                "My Cart",
                            ),

                            either(
                                cartSize < 1,
                                // Empty State
                                () =>
                                    h.div(
                                        {
                                            class: "bg-white p-5 rounded-4 shadow-sm text-center",
                                        },
                                        h.div(
                                            {
                                                class: "mb-3 text-muted opacity-25",
                                            },
                                            h.i({
                                                class: "fas fa-shopping-basket fa-4x",
                                            }),
                                        ),
                                        h.h5(
                                            { class: "fw-bold text-dark" },
                                            "Your cart is empty",
                                        ),
                                        h.p(
                                            { class: "text-secondary mb-4" },
                                            "Looks like you haven't added anything yet.",
                                        ),
                                        h.button(
                                            {
                                                class: "btn btn-primary rounded-pill px-4 fw-medium",
                                                style: "background: linear-gradient(-45deg, #973e87, #d946a6, #7a3270, #973e87); background-size: 400% 400%; animation: gradient 5s ease infinite; border: none;",
                                                onclick: h.func(
                                                    "app('router').to",
                                                    "app.search",
                                                ),
                                            },
                                            "Add An Item",
                                        ),
                                    ),
                                // List of Items
                                () =>
                                    h.div(
                                        { class: "d-flex flex-column gap-3" },
                                        ...each(cart.value, (item, key) => {
                                            let cartItem = item;
                                            total +=
                                                Number(cartItem.qty) *
                                                Number(cartItem.price);
                                            quantity += Number(cartItem.qty);

                                            // cartItem.price is already the actual
                                            // (deal-discounted where applicable) charge for
                                            // this line - undiscounted_price is the same
                                            // resolution with no discount applied, correctly
                                            // accounting for whatever price-affecting
                                            // feature/extra is selected (the base product's
                                            // own discounted_price doesn't apply once a
                                            // feature has replaced its price).
                                            if (
                                                cartItem.undiscounted_price !=
                                                    null &&
                                                Number(
                                                    cartItem.undiscounted_price,
                                                ) > Number(cartItem.price)
                                            ) {
                                                totalDiscount +=
                                                    (Number(
                                                        cartItem.undiscounted_price,
                                                    ) -
                                                        Number(
                                                            cartItem.price,
                                                        )) *
                                                    Number(cartItem.qty);
                                            }

                                            return h.CartProductView(item, {
                                                class: "",
                                            });
                                        }),
                                    ),
                            ),
                        ),

                        // RIGHT COLUMN: SUMMARY (4/12)
                        either(cartSize > 0, () =>
                            h.div(
                                { class: "col-12 col-lg-4" },
                                h.div(
                                    {
                                        class: "sticky-top",
                                        style: "top: 20px; z-index: 10;",
                                    }, // Sticky sidebar

                                    h.div(
                                        {
                                            class: "card border-0 shadow-sm rounded-4 overflow-hidden",
                                        },
                                        h.div(
                                            { class: "card-body p-4" },
                                            h.h5(
                                                { class: "fw-bold mb-4" },
                                                "Order Summary",
                                            ),

                                            // Summary Details
                                            h.div(
                                                {
                                                    class: "d-flex justify-content-between mb-2",
                                                },
                                                h.span(
                                                    { class: "text-secondary" },
                                                    "Items",
                                                ),
                                                h.span(
                                                    { class: "fw-medium" },
                                                    quantity,
                                                ),
                                            ),
                                            h.div(
                                                {
                                                    class: "d-flex justify-content-between mb-3",
                                                },
                                                h.span(
                                                    { class: "text-secondary" },
                                                    "Subtotal",
                                                ),
                                                h.span(
                                                    { class: "fw-bold" },
                                                    monetary(
                                                        total,
                                                        dc.userCurrency,
                                                    ),
                                                ),
                                            ),

                                            either(
                                                totalDiscount > 0,
                                                () =>
                                                    h.div(
                                                        {
                                                            class: "d-flex justify-content-between mb-3",
                                                        },
                                                        h.span(
                                                            {
                                                                class: "text-success fw-medium",
                                                            },
                                                            h.i({
                                                                class: "fas fa-tag me-2",
                                                            }),
                                                            "You're saving",
                                                        ),
                                                        h.span(
                                                            {
                                                                class: "fw-bold text-success",
                                                            },
                                                            monetary(
                                                                totalDiscount,
                                                                dc.userCurrency,
                                                            ),
                                                        ),
                                                    ),
                                            ),

                                            h.hr({ class: "my-3" }),

                                            h.div(
                                                {
                                                    class: "d-flex justify-content-between mb-4",
                                                },
                                                h.span(
                                                    {
                                                        class: "fs-5 fw-bold text-dark",
                                                    },
                                                    "Items Total",
                                                ),
                                                h.span(
                                                    {
                                                        class: "fs-5 fw-bold text-primary",
                                                    },
                                                    monetary(
                                                        total,
                                                        dc.userCurrency,
                                                    ),
                                                ),
                                            ),

                                            // Checkout Button
                                            v(uc.cart, (cart) => {
                                                return h.button(
                                                    {
                                                        class: "btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-lg d-flex justify-content-between align-items-center px-4",
                                                        onclick:
                                                            this.method(
                                                                "checkout",
                                                            ),
                                                    },
                                                    "Checkout",
                                                    h.i({
                                                        class: "fas fa-arrow-right",
                                                    }),
                                                );
                                            }),
                                        ),
                                        h.div(
                                            {
                                                class: "card-footer bg-light p-3 text-center",
                                            },
                                            h.small(
                                                { class: "text-muted" },
                                                "Secure Checkout",
                                            ),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                );
            }),
            ...args,
        );
    }

    $$ojs = {
        beforeRouteChange: () => {
            this.cleanUp();
        },
    };

    checkout() {
        return route.to("user.checkout");
    }

    cleanUp() {
        super.cleanUp();
    }

    $_mounted(componentId) {
        let c = component(componentId);

        if (!c || c.actionButtonShown) return;

        app('broker').send($e.cart.needs.allItems);

        if(cartEmpty()) return;

        showActionButton(
            () => route.to("user.checkout"),
            
            () =>
                v(uc.cart, (cart) => {
                    return h.span(
                        {
                            class: "d-flex justify-content-between align-items-center",
                        },
                        h.span("Checkout"),
                        h.i({
                            class: "fas fa-arrow-right",
                        }),
                    );
                }),
            true,
        );

        c.actionButtonShown = true;
    }
}
